import { parseISO, differenceInCalendarDays } from 'date-fns';

/**
 * Groups bookings of the same desk with consecutive dates into single entries.
 * Each group has: ids[], desk_id, start_date, end_date, and original booking fields.
 */
export function groupConsecutiveBookings(bookings) {
  if (!bookings || bookings.length === 0) return [];

  // Sort by desk_id then date
  const sorted = [...bookings].sort((a, b) => {
    if (a.desk_id !== b.desk_id) return a.desk_id - b.desk_id;
    return a.date.localeCompare(b.date);
  });

  const groups = [];
  let current = null;

  for (const b of sorted) {
    if (
      current &&
      current.desk_id === b.desk_id &&
      current.user_email === (b.user_email || '') &&
      isNextBusinessDay(current.end_date, b.date)
    ) {
      // Extend the group
      current.end_date = b.date;
      current.ids.push(b.id);
    } else {
      // Start new group
      if (current) groups.push(current);
      current = {
        ids: [b.id],
        desk_id: b.desk_id,
        start_date: b.date,
        end_date: b.date,
        user_name: b.user_name || '',
        user_email: b.user_email || '',
        created_at: b.created_at,
      };
    }
  }
  if (current) groups.push(current);

  return groups;
}

/**
 * Check if dateB is the next business day after dateA (skipping weekends).
 */
function isNextBusinessDay(dateStrA, dateStrB) {
  const a = parseISO(dateStrA);
  const b = parseISO(dateStrB);
  const diff = differenceInCalendarDays(b, a);

  // Direct next day
  if (diff === 1) return true;
  // Friday -> Monday (skip weekend)
  if (diff === 3 && a.getDay() === 5) return true;
  // Also handle cases where diff=2 and it's Sat->Mon 
  if (diff === 2 && a.getDay() === 5) return true;

  return false;
}
